import React from "react";
import { BaseIndicatorProps } from "../../lib/interface/Indicator.interface";
import { VectorCandleEvent } from "../../lib/interface/VectorCandleEvent.interface";
import { VectorCandleMarkers } from "../chart/VectorCandleMarkers";

/**
 * Props specific to Vector Candles indicator
 */
export interface VectorCandlesProps extends BaseIndicatorProps {
  vectorCandles: VectorCandleEvent[];
}

/**
 * Vector Candles Indicator Component
 * Shows buy/sell signal markers on the chart based on vector candle events
 */
export const VectorCandlesIndicator: React.FC<VectorCandlesProps> = ({
  chartInstance,
  candleSeries,
  isEnabled,
  vectorCandles,
}) => {
  // Only render if enabled
  if (!isEnabled) {
    return null;
  }

  return (
    <VectorCandleMarkers
      vectorCandles={vectorCandles}
      chartInstance={chartInstance}
      candleSeries={candleSeries}
      showVectorCandles={isEnabled}
    />
  );
};
